export {
	default as createLocalStorageBehavior,
	LOCAL_STORAGE_SET
} from './createLocalStorageBehavior';
